import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Welcome from '../views/Welcome'
import NoPage from '../views/404'
import OperationManual from '../views/OperationManual.vue'
// import AddEditSpu from '../views/Product/AddEditSpu.vue'

import Layout from "../views/Layout/Layout";
const _import = require('@/router/_import_' + process.env.NODE_ENV)//获取组件的方法

Vue.use(Router)

const createRouter = () => new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/404', component: NoPage, name: 'NoPage',
            meta: {
                title: 'NoPage',
                requireAuth: false,
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/',
            component: Welcome,
            name: '欢迎页',
            // hidden: true,
            meta: {
                title: '欢迎页',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/login',
            component: Login,
            name: 'login',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '登录',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/register',
            component: Register,
            name: 'register',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '注册',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/registerH5',
            component: resolve => require(['@/views/RegisterH5'], resolve),
            name: 'registerH5',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '注册',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/OperationBook',
            component: OperationManual,
            name: 'OperationBook',
            iconCls: ' fa-file-word-o',//图标样式class
            meta: {
                title: '操作手册',
                requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        // {
        //     path: '/Product/AddEditSpu',
        //     component: AddEditSpu,
        //     name: 'AddEditSpu',
        //     iconCls: 'fa-address-card',//图标样式class
        //     meta: {
        //         title: '商品详情',
        //         NoTabPage: true,
        //         NoNeedHome: true // 添加该字段，表示不需要home模板
        //     },
        //     hidden: true
        // },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        },
        {
            path: '/SupEnter',
            component: resolve => require(['@/views/SupEnter/Index'], resolve),
            meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
            hidden: true,
            children: [
                {
                    path: 'Step1',
                    component: resolve => require(['@/views/SupEnter/Step1'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
                {
                    path: 'Step2',
                    component: resolve => require(['@/views/SupEnter/Step2'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
                {
                    path: 'Step3',
                    component: resolve => require(['@/views/SupEnter/Step3'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
                {
                    path: 'State',
                    component: resolve => require(['@/views/SupEnter/State'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
            ]
        },
        {
            path: '/SupEnterH5',
            component: resolve => require(['@/views/SupEnterH5/Index'], resolve),
            meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
            hidden: true,
            children: [
                {
                    path: 'Step1',
                    component: resolve => require(['@/views/SupEnterH5/Step1'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
                {
                    path: 'Step2',
                    component: resolve => require(['@/views/SupEnterH5/Step2'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
                {
                    path: 'Step3',
                    component: resolve => require(['@/views/SupEnterH5/Step3'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
                {
                    path: 'State',
                    component: resolve => require(['@/views/SupEnterH5/State'], resolve),
                    meta: { title: '供应商入驻', NoTabPage: true, NoNeedHome: true },
                    hidden: true,
                },
            ]
        }
    ]
})

const router = createRouter()

export function filterAsyncRouter(asyncRouterMap) {
    //注意这里的 asyncRouterMap 是一个数组
    // console.log('asyncRouterMap', asyncRouterMap)
    const accessedRouters = asyncRouterMap.filter(route => {
        try {
            route.id = route.name;
            route.pid = route.customData.ParentId;
            route.name = route.displayName;
            route.IsButton = Boolean(route.customData.Type);
            route.path = route.url;
            route.iconCls = route.icon;
            route.meta = {
                title: route.displayName,
                requireAuth: route.customData.IsRequiresAuthentication,
                NoTabPage: false,
                keepAlive: route.customData.IsKeepAlive
            };
            let customExtension = JSON.parse(route.customData.CustomExtension);
            route.buttonShow = customExtension.buttonShow;
            route.buttonFunc = customExtension.buttonFunc;
            route.buttonType = customExtension.buttonType;
            route.children = route.items;
        } catch (e) {
            // console.log(e)
        }
        if (route.path && !route.IsButton) {
            if (route.path === '/' || route.path === '-') {//Layout组件特殊处理
                route.component = Layout
            } else {
                try {
                    // debugger
                    route.component = _import(route.path.replace('/:id', ''))
                    // console.log(_import(route.path.replace('/:id', '')), '11111111111122')
                } catch (e) {
                    try {
                        // debugger
                        route.component = () => import('@/views' + route.path.replace('/:id', '') + '.vue');
                        console.log(route.component, '222222222222211')
                        // route.component = (resolve) => require(["@/views" + route.path.replace('/:id','') + '.vue'], resolve)
                    } catch (error) {
                        console.info('%c 当前路由 ' + route.path.replace('/:id', '') + '.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
                    }
                }
            }
        }
        if (route.children && route.children.length && !route.IsButton) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })
    return accessedRouters
}

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}


router.$addRoutes = (params) => {
    var f = item => {

        if (item['children']) {
            item['children'] = item['children'].filter(f);
            return true;
        } else if (item['IsButton']) {
            return item['IsButton'] === false;
        } else {
            return true;
        }

    }
    var params = params.filter(f);

    router.addRoutes(params)
}

export default router;

